import React, {useState, useEffect} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import { formatDate } from 'react-day-picker/moment';
import { useGlobalState } from 'state-pool';
import _ from 'lodash';

import { DateTime } from 'luxon';
import Select from '../../../components/select';
import DayPicker from '../../../components/day-picker';
import Label from '../../../components/label';
import Note from '../../../components/note';
import LinkButton from '../../../components/link-button';
import ActionButton from '../../../components/action-button';
import InputNumeral from '../../../components/input-numeral';
import {postData} from '../../../helper/request-response';
import {onSuccess} from '../../../helper/toaster';
import constant from '../../../config/constant';
import saveDebPath from './config';
import { getPoBalance } from '../../../helper/cash-balance';

const Action = () => {
    
    const data = useLocation();
    
    const history = useHistory();

    const [, , setPoBalance] = useGlobalState('poBalance');

    const [isDisabledSave, setIsDisabledSave] = useState(true);

    const [isResetable, setIsResetable] = useState(true);

    const [isNew, setIsNew] = useState(true);
    
    const [titleInfo, setTitleInfo] = useState("");

    const [selectedCustName, setSelectedCustName] = useState(constant.DEFAULT_SELECTED);

    const [saveDeb, setsaveDeb] = useState(
        {
            id: 0,
            apArId: 0,
            trxDate: DateTime.local(),
            invoiceNo: `DB${DateTime.local().toFormat(constant.INVOICE_FORMAT)}`,
            invoiceLineNo: null,
            amount:0,
            masterCustomerId: 0,
            outstanding:0,
            custName:"",
            isChecked: 0,
            savingBalance:0,
            description: ""
        });

    const onInputChange = e => {

        const { name, value } = e.target;
        
        const saveDebData = {
            ...saveDeb,
            [name]: value
        } 

        setsaveDeb(saveDebData);
        
    };

    const onCheckboxChange = e => {

        if(saveDeb.isChecked === 0){
            setsaveDeb(data => ({
                ...data,
                amount: saveDeb.savingBalance,
                isChecked: saveDeb.isChecked === 1 ? 0 : 1
            }));
        }else{
            setsaveDeb(data => ({
                ...data,
                amount: 0,
                isChecked: saveDeb.isChecked === 1 ? 0 : 1
            }));
        }
        

    }

    const onAmountChange = values => {

        const { value } = values;
        const val = parseFloat(value);

        if (saveDeb.savingBalance >= val){
            setsaveDeb(data => ({
                ...data,
                amount: val,
                outstanding: calcOutstanding(data.savingBalance, val)
            }));
        }else{
            setsaveDeb(data => ({
                ...data,
                amount: saveDeb.savingBalance,
                outstanding:0
            }));
        }

        
    }

    /**
     * Customer change event.
     * @param {Object} opt - Option object.
     */
    const onChangeCustomer = opt => {

        if (opt.id) {

            setsaveDeb(data => ({
                ...data,
                apArId: opt.apArId,
                masterCustomerId: opt.id,
                custName: opt.name,
                savingBalance: opt.apAmount,
            }));

            setSelectedCustName(name => ({
                ...name,
                value: opt.id,
                label: opt.name
            }));
        } 
    }

    const onDayChange = day => {

        setsaveDeb({ 
            ...saveDeb,
            trxDate: formatDate(day, constant.DEFAULT_DATE)
        });
    }

    const onReset = e => {

        e.preventDefault();

        setsaveDeb(data => ({ 
            ...data,
                id: 0,
                apArId: 0,
                trxDate: DateTime.local(),
                invoiceNo: `DB${DateTime.local().toFormat(constant.INVOICE_FORMAT)}`,
                invoiceLineNo: null,
                amount:0,
                masterCustomerId: 0,
                outstanding:0,
                custName:"",
                isChecked: 0,
                description: ""
        }));

        setSelectedCustName(name => ({
            ...name,
            label: ""
        }));
    }

    /**
     * Calculate outstanding. Return 0 if the result less than 0.
     * @param {Number} savingBalance - Saving.
     * @param {Number} amount - Payment.
     */
    const calcOutstanding = (savingBalance, amount) =>  {
        
        const outstanding = parseFloat(savingBalance) - parseFloat(amount);

        return outstanding < 0 ? 0 : outstanding;
    };

    const onSubmit = (e) => {

        e.preventDefault();

        const postBankTrx = async () => {

            setIsDisabledSave(true);
            setPoBalance(0);

            const result = await postData(saveDebPath.baseApi, saveDeb);

            if (!_.isEmpty(result)) {

                onSuccess(`Transaksi ${result.invoice_no} berhasil di tambahkan`);

                history.goBack();

                getPoBalance();

            }
        };

        if (saveDeb.id === 0) postBankTrx();

    }

    useEffect(() => {

        function setsaveDebState() {

            if (data.state) {

                setsaveDeb(data.state)

                setTitleInfo(`Detail: ${data.state.invoiceNo}`);

                setSelectedCustName(code => ({
                    ...code,
                    value: data.state.custId,
                    label: data.state.custName
                }));

                setIsResetable(false);

                setIsNew(false);

            } else {

                setTitleInfo("Tambah Data Baru");

            }
        }

        setsaveDebState();

    }, [data]);

    useEffect(() => {

    if (saveDeb.custName && ( saveDeb.amount > 0) ) setIsDisabledSave(false);

    if (!saveDeb.custName || ( saveDeb.amount <= 0) ) setIsDisabledSave(true);

    }, [saveDeb.custName , saveDeb.amount]);

    return (

        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{saveDebPath.title} | {titleInfo}</h3>
            </div>

            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-right">
                        <div className="form-group row">
                            
                            <div className="col-md-12">
                            <Label htmlFor="account-type" text="No Pembayaran"/>
                                <input 
                                id="saveDeb-number"
                                type="text" 
                                className="form-control" 
                                name="invoiceNo"
                                value={saveDeb.invoiceNo}
                                onChange={ e => onInputChange(e) } 
                                readOnly
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <Label htmlFor="account-type" text="Tanggal"/>
                                <div>
                                    <DayPicker id="trx-date" name="trxDate" valueDate={saveDeb.trxDate} onDayChange={onDayChange} />
                                </div>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <Label htmlFor="customer-name" text="Pelanggan" isMandatory={ true } value={ saveDeb.custName } />
                                <Select
                                    id="customer-name"
                                    paramFilter="name"
                                    api={ saveDebPath.custFind }
                                    entityId="3,4"
                                    onChange={ onChangeCustomer }
                                    value={ selectedCustName }
                                />
                                <span><LinkButton to={ saveDebPath.newCustomer } className="stretched-link" label="Tambah Pelanggan Baru" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                    <form className="form-horizontal" onSubmit={ e => onSubmit(e) }>
                        {isNew &&
                        <div className="form-group row">
                            
                            <div className="col-md-12">
                            <Label htmlFor="account-type" text="Total Tabungan"/>
                                <InputNumeral 
                                    id="debtTotal"
                                    value={ saveDeb.savingBalance }
                                    display={ true }
                                    disabled
                                />
                            </div>
                        </div>
                        }

                        <div className="form-group row">
                           
                            <div className="col-md-12">
                            <Label htmlFor="account-type" text="Jumlah Penarikan" isMandatory={ true } value={ saveDeb.amount } />
                            <InputNumeral 
                                id="amount"
                                value={ saveDeb.amount }
                                onValueChange={ onAmountChange }
                            />
                            </div>
                        </div>
                        {isNew &&
                        <div className="form-group row">
                            
                            <div className="col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input 
                                        id="pay-all"
                                        type="checkbox"
                                        className="custom-control-input"
                                        name="payAll"
                                        value={ saveDeb.isChecked }
                                        checked={ saveDeb.isChecked }
                                        onChange={ e => onCheckboxChange(e) }
                                    />   
                                    <label htmlFor="pay-all" className="custom-control-label">Tarik Semua</label>
                                </div>
                            </div>
                            
                        </div>
                        }
                        <div className="form-group row">
                            
                            <div className="col-md-12">
                            <Label htmlFor="saveDeb-description" text="Deskripsi"  isMandatory={ true } value={ saveDeb.description }/>
                                <input 
                                id="saveDeb-description"
                                type="text" 
                                className="form-control" 
                                name="description"
                                value={saveDeb.description}
                                onChange={ e => onInputChange(e) } 
                                />
                            </div>
                        </div>

                        {isNew &&
                        <div className="form-group row">
                            
                            <div className="col-md-12">
                            <Label htmlFor="outstanding" text="Sisa Tabungan"/>
                                <InputNumeral 
                                    id="outstanding"
                                    value={ saveDeb.outstanding }
                                    display={ true }
                                />
                            </div>
                            
                        </div>
                        }
                        
                        <div className="form-group row">
                            <div className="col-md-12">
                            <Label />
                                <ActionButton 
                                    isSave={ isNew }
                                    isDisabledSave={ isDisabledSave } 
                                    isReset={ isResetable } 
                                    onReset={ onReset } />
                            </div>
                        </div>

                        <Note isAction={ true } />
                    
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Action;
